import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { BuildSvg } from './BuildSvg'

export const EaBuildIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={BuildSvg} {...props} />
)
